import styled from 'styled-components';
import { GatsbyImage } from "gatsby-plugin-image"

export const ExampleImg = styled(GatsbyImage)`
    margin-top: ${props => props.marginTop || 0}; 
    margin-left: ${props => props.marginLeft || 0}; 
    margin-right: ${props => props.marginRight || 0}; 
    margin-bottom: ${props => props.marginBottom || 0};
    width: ${props => props.width || "unset"};
    height: ${props => props.height || "unset"};
`;
